import Termination from "../account/Termination";

const Terminate = () => {
  return (
    <div className="d-flex justify-content-center">
      <div className="rtl-all" style={{ width: "21cm" }}>
        <Termination />
      </div>
    </div>
  );
};

export default Terminate;
